import type { PolicySettings } from './contracts';

/** Starting points copied into ordinary drafts, never a live binding or execution authority. */
export const policyProfiles = [
  { id: 'workstation', name: 'Workstation', description: 'Security and quality updates. No automatic restarts.',
    settings: { patchApproval: 'security-quality', reboot: 'never' } },
  { id: 'server', name: 'Server', description: 'Security updates only. No automatic restarts.',
    settings: { patchApproval: 'security', reboot: 'never' } },
] as const;
export type PolicyProfileId = typeof policyProfiles[number]['id'];

/** Keep windows, exclusions and protection exceptions; the caller also keeps reasons, expiry and locks. */
export function profileSettings(current: Partial<PolicySettings>, profile: PolicyProfileId | 'inherit'): Partial<PolicySettings> {
  const settings = structuredClone(current);
  if (profile === 'inherit') {
    delete settings.patchApproval;
    delete settings.reboot;
  } else Object.assign(settings, policyProfiles.find(p => p.id === profile)!.settings);
  return settings;
}
